import { EOSService } from "../../api/eos-service";
import { MissionService } from "../../api/mission-service";
//import EosUtils from '../../utils/EosUtils'

const state = {
};

const getters = {};

const actions = {
    async PersonMissionList(state, { params }) {
        var perno = state.rootState.auth.auth.username;
        if (!params.get('perno')) {
            params.append('perno', perno);
        }
        params.append('sortType', 'Desc');
        params.append('sortExpression', 'beginDate');

        return await EOSService.makeRequest(MissionService.PersonMissionList(params))
    },
    async AddMission(state, { params }) {
        if (!params.get('perno')) {
            var perno = state.rootState.auth.auth.username;
            params.append('perno', perno);
        }

        return await EOSService.makeRequest(MissionService.AddMission(params))
    },
    async GetWebMissionTypeList() {
        return await EOSService.makeRequest(MissionService.GetWebMissionTypeList())
    },
    async GetAllMissionTypeList() {
        return await EOSService.makeRequest(MissionService.GetAllMissionTypeList())
    },
    async GetMissionCityList() {
        return await EOSService.makeRequest(MissionService.GetCityList())
    },
    async GetMissionDetailForPerson(state, { params }) {
        if (!params.get('perno') /*&& !EosUtils.isWebKartAdmin()*/) {
            var perno = state.rootState.auth.auth.username;
            params.append('perno', perno);
        }

        return await EOSService.makeRequest(MissionService.GetMissionDetailForPerson(params))
    },
    async OprationOnMissionArchive(state, { params }) {
        return await EOSService.makeRequest(MissionService.OprationOnMissionArchive(params))
    },
    async OprationOnMissionRequest(state, { params }) {
        return await EOSService.makeRequest(MissionService.OprationOnMissionRequest(params))
    },
    async GetMissionListForAdmins(state, { params }) {
        var perno = state.rootState.auth.auth.username;
        params['adminPerno'] = perno;
        return await EOSService.makeRequest(MissionService.GetMissionListForAdmins(params))
    },
    async GetMissionApproveDegree(state, { approveParams }) {
        var perno = state.rootState.auth.auth.username;
        approveParams['adminPerno'] = perno;
        return await EOSService.makeRequest(MissionService.GetApproveDegree(approveParams))
    },
    async GetMissionDetailForAdmin(state, { params }) {
        var perno = state.rootState.auth.auth.username;
        params.append('adminPerno', perno);
        return await EOSService.makeRequest(MissionService.GetMissionDetailForAdmin(params))
    },
    async GetMissionHourForMission(state, { GetMissionHourForMissionParams }) {
        var params = new URLSearchParams()
        params.append('pageNo', GetMissionHourForMissionParams.pageNo);
        params.append('year', GetMissionHourForMissionParams.year);
        params.append('dbKind', GetMissionHourForMissionParams.dbKind);
        return await EOSService.makeRequest(MissionService.GetMissionHourForMission(params))
    },
    async GetPeriodMissionDetail(state, { GetPeriodMissionDetailParams }) {
        var params = new URLSearchParams()
        params.append('perno', GetPeriodMissionDetailParams.perno)
        params.append('period', GetPeriodMissionDetailParams.period)
        params.append('year', GetPeriodMissionDetailParams.year)
        params.append('isPeriod', GetPeriodMissionDetailParams.isPeriod)
        return await EOSService.makeRequest(MissionService.GetPeriodMissionDetail(params))
    },
    async GetMissionPageNo(state, { params }) {
        var _params = new URLSearchParams()
        _params.append('perno', params.perno)
        _params.append('beginDate', params.beginDate)
        _params.append('endDate', params.endDate)
        _params.append('missionType', params.missionType)
        _params.append('year', params.year)
        return await EOSService.makeRequest(MissionService.GetMissionPageNo(_params))
    },
    async AddMissionHour(state, { data }) {
        var _data = {
            BeginDate: data.BeginDate,
            EndDate: data.EndDate,
            BeginTime: data.BeginTime,
            EndTime: data.EndTime,
            Perno: data.Perno,
            Description: data.Description,
            MissionType: data.MissionType,
            PageNo: data.PageNo,
            CityCode: data.CityCode,
            Place: data.Place,
        }
        debugger
        return await EOSService.makeRequest(MissionService.AddMissionHour(_data))
    },
};

const mutations = {
};

export default {
    state,
    getters,
    actions,
    mutations
}